export default __webpack_public_path__ + "static/media/flexicare.817ff9f0.png";